import * as React from 'react';
import Page from '../../containers/Page';
import LanguageSelector from '../../containers/ParametersPage/Language';
import NavigationSelector from '../../containers/ParametersPage/Navigation';
import AppInfos from '../../containers/ParametersPage/AppInfos';
import ActionButtons from '../../containers/ParametersPage/ActionButtons';
import { PageType } from '../../containers/Page/constants';

const ParametersPage = () => {
	return (
		<Page
			pageType={PageType.ParametersPage}
			title="messages.my_parameters"
		>
			<LanguageSelector />
			<NavigationSelector />
			<AppInfos />
			<ActionButtons />
		</Page>
	);
};

export default ParametersPage;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ParametersPage/index.tsx